import { Skeleton } from '@/components/ui/Skeleton';
import { useAdminMaintenances } from '@/hooks/useAdminCommunications';
import { MaintenanceCalendar } from '../components/MaintenanceCalendar';

export function MaintenanceSchedulePage() {
  const { data, isLoading } = useAdminMaintenances({});
  const maintenances = data?.data?.data || [];

  return (
    <div className="space-y-6">
      <div><h1 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">Maintenance</h1><p className="text-sm text-neutral-500">Planification des maintenances</p></div>
      {isLoading ? <Skeleton className="h-64" /> : <MaintenanceCalendar maintenances={maintenances} />}
    </div>
  );
}
